import React from "react";


export const formFields = {
  password: {
    key: 'password',
    type: 'password',
    label: 'Enter New Password',
    required: true,
    placeholder: 'Password',
    requiredMessage: 'Password is required.',
    displayLayout: 'col-sm-12',
    pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=(?:.*\d.*\d))(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    patternMessage: `Your password must meet the following criteria:`,
    // patternMessage: 'Password contain at least five character two digit and one capital character.',
    // maxLength: 5,
    // maxLengthMessage: 'maximum 5 characters allowed.',
    spaceNotAllowed: true,
    labelLayout: 'col-sm-12'
  },
  confirmPw: {
    key: 'confirmPw',
    type: 'password',
    label: 'Confirm Password',
    required: true,
    placeholder: 'Confirm Password',
    requiredMessage: 'Confirm password is required',
    displayLayout: 'col-sm-12',
    pattern: /^(?=.*[A-Z])(?=(?:.*[a-z]){5,})(?=(?:.*\d.*\d))(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    patternMessage: 'Your password must meet the following criteria:',
    // patternMessage: 'The Password Should Contain Six Letters Including One Capital Letter and Two Digits',
    // maxLength: 10,
    // maxLengthMessage: 'maximum 10 characters allowed.',
    spaceNotAllowed: true,
    labelLayout: 'col-sm-6',
    customError: false,
    customErrorMessage: "Password does not match"
  },

};